import { createSlice } from "@reduxjs/toolkit";

const loadInitialState = () => {
  const user = localStorage.getItem("trp_agt");
  const token = localStorage.getItem("trp_agt_tk");

  let parsedUser = null;
  if (user) {
    try {
      parsedUser = JSON.parse(user);
    } catch (error) {
      localStorage.removeItem("trp_agt");
    }
  }
  return {
    user: parsedUser,
    token: token || null,
    isAuthenticated: !!token,
  };
};

const initialState = loadInitialState();

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser(state, action) {
      state.user = action.payload;
      state.isAuthenticated = true;
      localStorage.setItem("trp_agt", JSON.stringify(action.payload));
    },
    setToken(state, action) {
      state.token = action.payload;
      state.isAuthenticated = true;
      localStorage.setItem("trp_agt_tk", action.payload);
    },
    loginSuccess(state, action) {
      const { user, token } = action.payload;
      state.user = user;
      state.token = token;
      state.isAuthenticated = true;
      localStorage.setItem("trp_agt", JSON.stringify(user));
      localStorage.setItem("trp_agt_tk", token);
    },
    clearUser(state) {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      localStorage.removeItem("trp_agt");
      localStorage.removeItem("trp_agt_tk");
    },
    logout(state) {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      localStorage.removeItem("trp_agt");
      localStorage.removeItem("trp_agt_tk");
    },
    updateProfile(state, action) {
      const updatedUser = { ...state.user, ...action.payload };
      state.user = updatedUser;
      localStorage.setItem("trp_agt", JSON.stringify(updatedUser));
    },
  },
});

export const { setUser, setToken, loginSuccess, clearUser, logout, updateProfile } =
  authSlice.actions;
export default authSlice.reducer;
